<template>
	<div>
		<el-card class="login-form-layout">
			<el-form autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm" label-position="left">

				<h2 class="login-title color-main">
					<img src="../assets/logo.png" style="height: 50px;width: 50px;margin-right:10px"/>
					NSP管理系统</h2>
				<el-form-item prop="username">
					<el-input name="username" type="text" v-model="loginForm.username" autoComplete="on"
						placeholder="请输入用户名" clearable>
					</el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input name="password" :type="pwdType" @keyup.enter.native="handleLogin"
						v-model="loginForm.password" autoComplete="on" placeholder="请输入密码" clearable show-password>
					</el-input>
				</el-form-item>
				<el-form-item style="margin-bottom: 40px; display: flex;flex-direction: row;justify-content: center;">
					<el-button style="width: 100%;" type="primary" :loading="loading"
						@click.native.prevent="handleLogin">
						登录
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<img :src="login_center_bg" class="login-center-layout" />
	</div>
</template>
<script>
	import login_center_bg from "@/assets/images/login_center_bg.png";
	import {
		isvalidUsername
	} from "@/api/validate";
	export default {
		name: "app",
		data() {
			const validateUsername = (rule, value, callback) => {
				if (!isvalidUsername(value)) {
					callback(new Error("请输入正确的用户名"));
				} else {
					callback();
				}
			};
			const validatePass = (rule, value, callback) => {
				if (value.length < 3) {
					callback(new Error("密码不能小于3位"));
				} else {
					callback();
				}
			};
			return {
				loginForm: {
					username: "",
					password: "",
				},
				loginRules: {
					username: [{
						required: true,
						trigger: "blur",
						validator: validateUsername
					}, ],
					password: [{
						required: true,
						trigger: "blur",
						validator: validatePass
					}, ],
				},
				loading: false,
				pwdType: "password",
				login_center_bg,
				dialogVisible: false,
				supportDialogVisible: false,
				loading: false,
				name: '',
				pwd: ''
			};
		},
		methods: {
			showPwd() {
				if (this.pwdType === "password") {
					this.pwdType = "";
				} else {
					this.pwdType = "password";
				}
			},
			handleLogin() {
				this.$refs.loginForm.validate((valid) => {
					if (valid) {
						this.loading = true;
						this.loading = true
						this.$api.login(this.loginForm).then((res) => {
							// console.log(res)
							if (res.state == 'success') {
								var storage = window.sessionStorage;
								storage.setItem('token', res.data.token);
								
								this.$store.commit('setkey',res.data.publicKey)
								this.$router.push('/home')
							} else {
								this.$message.error(res.message);
							}
							this.loading = false
						})
					} else {
						console.log("参数验证不合法！");
						return false;
					}
				});
			},
			handleTry() {
				this.dialogVisible = true;
			},
			dialogConfirm() {
				this.dialogVisible = false;
				setSupport(true);
			},
			dialogCancel() {
				this.dialogVisible = false;
				setSupport(false);
			}
		},
		created() {
			let user = window.sessionStorage.getItem('token');
			if (user) {
				this.$router.push('/home')
			}
		}
	};
</script>
<style>
	.login-form-layout {
		position: absolute;
		left: 0;
		right: 0;
		width: 360px;
		margin: 140px auto;
		border-top: 10px solid #409eff;
	}

	.login-title {
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 20px;
	}

	.login-center-layout {
		background: #409eff;
		width: auto;
		height: auto;
		max-width: 100%;
		max-height: 100%;
		margin-top: 200px;
	}
</style>
